import React, { useEffect } from 'react'
import injectStyles from 'react-jss'
import { styles } from './styles'
import { MenuItem, Select } from '@material-ui/core'
import ListSubheader from '@material-ui/core/ListSubheader'
import FormControl from '@material-ui/core/FormControl'
import { DEFAULT_VALUES_PLACEHOLDER } from '../../options'

const GroupSelect = ({
  onChange,
  value,
  options,
  label,
  classes,
  handleClick = () => {},
  disableDefaultValue = false,
  labelClassName,
  displayColumn,
  fullWidth,
}) => {
  const handleChange = e => {
    if (e.target) {
      onChange(e.target.value)
    }
  }

  useEffect(() => {
    if (!disableDefaultValue && !value) {
      onChange(DEFAULT_VALUES_PLACEHOLDER.NONE)
    }
  }, [value])

  return (
    <FormControl
      className={`${classes.formControl} ${
        displayColumn ? classes.flexColumn : ''
      } ${fullWidth ? classes.fullWidth : ''}`}
    >
      <span
        className={`${classes.label} ${labelClassName ? labelClassName : ''}`}
      >
        {label}:
      </span>
      <Select
        onOpen={handleClick}
        id="grouped-select"
        value={value}
        onChange={handleChange}
        className={`${classes.select} ${fullWidth ? classes.fullWidth : ''}`}
        variant="outlined"
      >
        {!disableDefaultValue ? (
          <MenuItem
            className={classes.menuItemStyle}
            dense={false}
            value={DEFAULT_VALUES_PLACEHOLDER.NONE}
          >
            <em>None</em>
          </MenuItem>
        ) : null}
        {options.map(item =>
          item.isSubHead ? (
            <ListSubheader
              key={item.id}
              disableGutters={true}
              disableSticky={true}
              className={classes.topicItemStyle}
            >
              {item.label}
            </ListSubheader>
          ) : (
            <MenuItem
              key={item.id}
              className={classes.menuItemStyle}
              dense={false}
              value={item.value}
            >
              {item.label}
            </MenuItem>
          ),
        )}
      </Select>
    </FormControl>
  )
}

export default injectStyles(styles)(GroupSelect)
